import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=51bd9972"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"
import style0 from "./ContactSection.vue?vue&type=style&index=0&id=51bd9972&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentSwiper: require('/vercel/path0/components/content/Swiper.vue').default,Richtext: require('/vercel/path0/components/elements/Richtext.vue').default,Button: require('/vercel/path0/components/elements/Button.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
